import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_actions = _resolveComponent("actions")!
  const _component_insights = _resolveComponent("insights")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_latest_post_import = _resolveComponent("latest-post-import")!
  const _component_edit_username = _resolveComponent("edit-username")!
  const _component_delete_account = _resolveComponent("delete-account")!
  const _component_app_user = _resolveComponent("app-user")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showActions)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
          _createVNode(_component_actions, { account: _ctx.account }, null, 8, ["account"])
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_insights, {
      account: _ctx.account,
      class: "q-py-lg"
    }, null, 8, ["account"]),
    _createVNode(_component_q_separator),
    (_ctx.latestImport)
      ? (_openBlock(), _createBlock(_component_latest_post_import, {
          key: 1,
          "post-import": _ctx.latestImport,
          platform: _ctx.account.socialSite.name,
          class: "q-pa-lg",
          onRunning: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isImporting = true)),
          onSuccessful: _ctx.onImportSuccess,
          onFailed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isImporting = false))
        }, null, 8, ["post-import", "platform", "onSuccessful"]))
      : _createCommentVNode("", true),
    _createVNode(_component_app_user, null, {
      default: _withCtx(({ isServiceProvider, isCustomer }) => [
        isServiceProvider
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_q_separator),
              _createVNode(_component_edit_username, {
                account: _ctx.account,
                "onUpdate:account": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:account', $event)))
              }, null, 8, ["account"])
            ], 64))
          : _createCommentVNode("", true),
        (isServiceProvider || isCustomer)
          ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
          : _createCommentVNode("", true),
        (isServiceProvider || isCustomer)
          ? (_openBlock(), _createBlock(_component_delete_account, {
              key: 2,
              account: _ctx.account,
              class: "q-pa-lg"
            }, null, 8, ["account"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}